import { queryBot2 } from 'boot/axios';

export async function loadRoles () {
    return queryBot2('loadRoles').then((r) => {
        let roles;
        const result = r.data;
        if (result && typeof result === 'object') {
            roles = result;
        }
        return roles;
    });
}

export async function loadStatuses () {
    return queryBot2('loadStatuses').then((r) => {
        let statuses;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            statuses = r.data;
        }
        return statuses;
    });
}

export async function loadCourses () {
    return queryBot2('loadCourses').then((r) => {
        const result = r.data;
        if (!result || typeof result !== 'object') {
            return undefined;
        }
        const courses = {};
        result.forEach((i) => {
            courses[i.id] = i;
        });
        return courses;
    });
}

export async function loadLimits (portfolioId) {
    return queryBot2('loadLimits', { portfolioId }).then(async (r) => {
        const [result] = r.data;
        if (!result || typeof result !== 'object') {
            return undefined;
        }
        const roles = await loadRoles();
        if (!roles || typeof roles !== 'object') {
            return undefined;
        }
        const limits = {};
        await roles.forEach((i) => {
            const role = i.name;
            const limit = result[`limit_${role}`];
            limits[role] = limit ? parseInt(result[`limit_${role}`], 10) : undefined;
        });
        return limits;
    });
}

export default loadStatuses;
